<div class="px-lg-0 checklist-wrapper">
   <!-- Show loader while loading2 is true -->
   <div class="loader-wrapper" *ngIf="loading2">
      <ngx-skeleton-loader
         count="4"
         [theme]="{
            'border-radius': '5px',
            height: '50px',
            'background-color': '#ededed'
         }"
      >
      </ngx-skeleton-loader>
   </div>

   <!-- Show actual content after loading2 is false -->
   <ng-container *ngIf="!loading2">
      <!-- Locked Card for users who can't access -->
      <!-- Checklist content for accessible users -->
      <ng-container *ngIf="canReadInvestmentChecklist || isSample">
         <!-- Show "No Data" message if investmentData is missing or has no meaningful content -->
         <div *ngIf="!hasValidData()" class="text-center py-5">
            <p style="font-size: 16px; color: #888">
               No data available for this investment.
            </p>
         </div>

         <!-- Render checklist if valid data is available -->
         <ng-container *ngIf="hasValidData()">
            <div
               style="
                  max-width: 680px;
                  border-radius: 12px;
                  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
                  overflow: hidden;
                  margin: 0 auto;
                  background-color: white;
               "
            >
               <div style="padding-top: 24px">
                  <div
                     style="
                        display: flex;
                        align-items: center;
                        border-left: 4px solid #4caf50;
                        padding-left: 16px;
                     "
                  >
                     <h1 style="margin: 0; font-size: 24px; font-weight: 600">
                        Investment Checklist
                     </h1>
                  </div>

                  <!-- Expected Annual Return -->
                  <div
                     style="
                        padding: 22px;
                        border-bottom: 1px solid #f0f0f0;
                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
                     "
                  >
                     <div style="display: flex; align-items: center">
                        <div
                           [ngStyle]="{
                              width: '30px',
                              height: '30px',
                              'border-radius': '50%',
                              'background-color':
                                 investmentData.expected_annual_return >= 0
                                    ? '#e8f5e9'
                                    : '#ffebee',
                              display: 'flex',
                              'align-items': 'center',
                              'justify-content': 'center',
                              'margin-right': '12px',
                              'flex-shrink': '0'
                           }"
                        >
                           <span
                              *ngIf="investmentData.expected_annual_return >= 0"
                              style="font-size: 16px; color: #4caf50"
                           >
                              ▲
                           </span>
                           <span
                              *ngIf="investmentData.expected_annual_return < 0"
                              style="font-size: 16px; color: #f44336"
                           >
                              ▼
                           </span>
                        </div>

                        <h2
                           style="font-size: 16px; font-weight: 600; margin: 0"
                        >
                           {{ investmentData.expected_annual_return }}% Expected
                           Annual Return
                        </h2>
                     </div>

                     <p
                        style="
                           margin: 8px 0 0 0;
                           font-size: 12.8px;
                           color: #666;
                           line-height: 1.5;
                        "
                     >
                        Based on 1 year median target stock price of
                        {{
                           investmentData.target_price
                              | sumPipe : currency || ""
                        }}
                        and annual dividend yield of
                        {{ investmentData.dividendYield }}%
                     </p>
                  </div>

                  <!-- High Risk -->
                  <div
                     style="
                        padding: 22px;
                        border-bottom: 1px solid #f0f0f0;
                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
                     "
                  >
                     <div style="display: flex; align-items: center">
                        <div
                           [ngStyle]="{
                              width: '30px',
                              height: '30px',
                              'border-radius': '50%',
                              'background-color': getRiskBackgroundColor(
                                 investmentData.risk_level
                              ),
                              display: 'flex',
                              'align-items': 'center',
                              'justify-content': 'center',
                              'margin-right': '12px',
                              'flex-shrink': 0
                           }"
                        >
                           <i
                              class="fa-solid fa-exclamation"
                              [ngStyle]="{
                                 color: getRiskIconColor(
                                    investmentData.risk_level
                                 )
                              }"
                           ></i>
                        </div>

                        <h2
                           *ngIf="investmentData?.risk_level; else noRisk"
                           style="font-size: 16px; font-weight: 600; margin: 0"
                        >
                           {{ getRiskLevelLabel(investmentData.risk_level) }}
                        </h2>
                        <ng-template #noRisk> - </ng-template>
                     </div>
                     <p
                        style="
                           margin: 8px 0 0 0;
                           font-size: 12.8px;
                           color: #666;
                           line-height: 1.5;
                        "
                     >
                        This stock is
                        {{ investmentData?.risk_level | number : "1.2-2" }}x as
                        volatile as the {{ investmentData?.index || "-" }}
                     </p>
                  </div>

                  <!-- Sharpe Ratio -->
                  <div
                     style="
                        padding: 22px;
                        border-bottom: 1px solid #f0f0f0;
                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
                     "
                  >
                     <div style="display: flex; align-items: center">
                        <div
                           style="
                              width: 30px;
                              height: 30px;
                              border-radius: 50%;
                              background-color: #ffeded;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                              margin-right: 12px;
                              flex-shrink: 0;
                           "
                        >
                           <span
                              class="icon-span pos icon-caret d-flex align-items-center justify-content-center"
                              [ngStyle]="{
                                 width: '30px',
                                 height: '30px',
                                 'border-radius': '50%',
                                 'background-color': getSharpeTextColor(
                                    investmentData.sharpe_ratio
                                 )
                              }"
                           >
                              <i
                                 class="fa-solid fa-scale-balanced"
                                 [ngStyle]="{
                                    fontSize: '13px',
                                    color: getSharpeColor(
                                       investmentData.sharpe_ratio
                                    )
                                 }"
                              ></i>
                           </span>
                        </div>
                        <h2
                           style="font-size: 16px; font-weight: 600; margin: 0"
                        >
                           {{ getSharpeRating(investmentData.sharpe_ratio) }}
                           Sharpe Ratio
                        </h2>
                     </div>
                     <p
                        style="
                           margin: 8px 0 0 0;
                           font-size: 12.8px;
                           color: #666;
                        "
                     >
                        This stock has a Sharpe ratio of
                        {{ investmentData.sharpe_ratio | number : "1.2-2" }} and
                        is expected to give
                        {{ getSharpeRating(investmentData.sharpe_ratio) }}
                        returns compared to the risk involved.
                     </p>
                  </div>

                  <!-- Dividend Yield -->
                  <div
                     style="
                        margin-bottom: 0;
                        padding: 22px;
                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
                     "
                  >
                     <div
                        style="
                           display: flex;
                           align-items: center;
                           margin-bottom: 6px;
                        "
                     >
                        <div
                           [ngStyle]="{
                              width: '30px',
                              height: '30px',
                              'border-radius': '50%',
                              'background-color': getBackgroundColor(
                                 investmentData.scale
                              ),
                              display: 'flex',
                              'align-items': 'center',
                              'justify-content': 'center',
                              'margin-right': '12px',
                              'flex-shrink': 0
                           }"
                        >
                           <span
                              [ngSwitch]="
                                 getScaleIndicator(investmentData.scale)
                              "
                           >
                              <span
                                 *ngSwitchCase="'higher'"
                                 style="font-size: 16px; color: #4caf50"
                                 >▲</span
                              >
                              <span
                                 *ngSwitchCase="'lower'"
                                 style="font-size: 16px; color: #f44336"
                                 >▼</span
                              >
                              <span
                                 *ngSwitchCase="'equal'"
                                 style="font-size: 16px; color: #9e9e9e"
                                 >=</span
                              >
                              <span
                                 *ngSwitchDefault
                                 style="font-size: 16px; color: #9e9e9e"
                                 >—</span
                              >
                           </span>
                        </div>
                        <h2
                           style="font-size: 16px; font-weight: 600; margin: 0"
                        >
                           {{ investmentData.dividendYield }}% Dividend Yield
                        </h2>
                     </div>
                     <p
                        class="mb-0 checklist-para d-inline-block"
                        style="font-size: 12.8px"
                     >
                        <span>{{ investmentData.scale }}</span>
                     </p>
                  </div>
               </div>
            </div>
         </ng-container>
      </ng-container>

      <!-- Checklist content for accessible users -->
   </ng-container>
</div>
